"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetListOverview = void 0;
const button_1 = require("client/components/material/button");
const mobx_react_1 = require("mobx-react");
const React = require("react");
require("./asset-list-overview.less");
let AssetListOverview = class AssetListOverview extends React.Component {
    render() {
        return (React.createElement("div", { className: "asset-list-overview" },
            React.createElement("div", { className: "asset-list-overview__btn-container" },
                React.createElement(button_1.MaterialButton, { secondary: true, onClick: this.props.onClick }, this.props.btnLabel)),
            React.createElement("div", { style: { marginTop: 12 }, className: "asset-list-overview__list-container" }, this.props.children)));
    }
};
AssetListOverview = __decorate([
    mobx_react_1.observer
], AssetListOverview);
exports.AssetListOverview = AssetListOverview;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/asset-list-overview/asset-list-overview.tsx
// module id = 3433
// module chunks = 0